import { loadStripe, type Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Singleton de Stripe.js. Antes cada surface llamaba `loadStripe()` a nivel de
 * módulo en el bundle inicial, bajando js.stripe.com (~500KB) en cada boot.
 * Ahora el SDK baja la primera vez que algo lo pide; el warmup en idle
 * (prefetchRoutes) lo precalienta poco después del boot para conservar las
 * señales antifraude de Radar sin competir con la carga inicial.
 */
export const getStripe = (): Promise<Stripe | null> => {
	stripePromise ??= loadStripe(import.meta.env.VITE_STRIPE_API_KEY as string);
	return stripePromise;
};
